import { DatePipe, JsonPipe, Location, LowerCasePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as c3 from 'c3';
import { AuthService } from 'src/app/services/auth.service';
// import { NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerModule, NgxExtendedPdfViewerService, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';

import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { ChangeDetectorRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { waitForAsync } from '@angular/core/testing';
// import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { Observable } from 'rxjs';
import config from '../../../assets/config.json';
import { debugOutputAstAsTypeScript, devOnlyGuardedExpression } from '@angular/compiler';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { DomSanitizer } from '@angular/platform-browser';
import { WorkflowStatusComponent } from 'src/app/components/unitwise-dashboard/workflow-status/workflow-status.component'
import{MemoryStorageService} from 'src/app/services/memory-storage.service';

declare var $: any;
@Component({
  selector: 'app-unitwise-dashboard',
  templateUrl: './unitwise-dashboard.component.html',
  styleUrls: ['./unitwise-dashboard.component.css']
})
export class UnitwiseDashboardComponent implements OnInit {


  MONTHS: any = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  lstTable: any = [];
  frm: FormGroup;
  showSearchBy: boolean = false;
  fields: any = [];
  frmInitialValues: any = {};

  monthDropdown: any = [];
  monthDefault: string = "";
  documentTypeName: string = "";

  calendarDate: string = "";

  isAction: boolean = false;
  actionText: string = "";
  actionTable: any = [];
  actionTableColumns: any = [];
  actionTableMore: boolean = false;

  isSlaChartTableOpen: boolean = false;
  isCriticalTableOpen: boolean = false;
  isCompletedTableOpen: boolean = false;
  isActivityStatusTableOpen: boolean = false;

  slaTableColumns: any = [];
  criticalTableColumns: any = [];
  completedTableColumns: any = [];

  slaTableData: any = [];
  criticalTableData: any = [];
  completedTableData: any = [];
  calendarTableData: any = [];

  calendarMonthYear: string = "";
  calendarData: any = [];
  graphData: any = [];
  missedGraphData: any = [];
  calendarDaywiseData: any = [];
  calendarHolidayMonthData: any = [];
  calendarPositionData: any = [];
  statusCountdata: any = [];
  invoiceDueDatewise: any = [];
  activityGrowthData: any = [];
  activityTypeData: any = [];
  activityClosureData: any = [];
  activityPerformanceData: any = [];
  slaGraphData: any = [];

  documentTabList: any = [];
  overallActivityList: any = [];
  overallActivityGraphList: any = [];
  criticalActivityList: any = [];

  isAdmin: boolean = false;
  Compliance_Title: string = "";

  charttabledata = [
    { activityname: 1, activitytype: 'Weekly', duedate: '10-Dec-2021 11:50' },
    { activityname: 2, activitytype: 'Monthly', duedate: '10-Jan-2021 11:50' }
  ];
  isMonthendActivity: boolean = false;

  selectedDisplay: string = "";
  totalCount: number = 0;
  totalCriticalCount: number = 0;
  activeDocument: number = 0;

  tableColumns: any = [];
  tableRows: any = [];
  gridBackup: any = [];
  gridBackupColumns: any = [];
  tableTitle: string = "";

  @ViewChild('workflowStatusComponent', { static: false }) workflowStatusComponent: WorkflowStatusComponent;

  constructor(
    private dataService: DataService,
    public commonService: CommonService,
    private router: Router,
    private authService: AuthService,
    private dialog: MatDialog,
    private memorystore: MemoryStorageService
  ) {
    //this.commonService.showHideLoader(true);
  }

  ngOnInit(): void {
    this.lstTable = [];
    // this.commonService.showHideLoader(true);
    //this.authService.checkProxy();
    this.documentTabList = [];
    this.getGraphData();
    this.initActivityFields();
    this.showSearchBy = false;
    $(document).ready(function () {
      $('.carousel').carousel({
        fullWidth: true,
        indicators: true
      });
    });
  }

  getRowIndex(row) {
    return this.tableRows.indexOf(row) + 1;
  }

  async getTabularData(item) {
    this.tableColumns = [];
    this.tableRows = [];
    this.tableTitle = "";

    let body = {
      Action: "VwREPORT",
      // ActionBy: this.commonService.getUserInfoFromLocalStorage("userName"),
      // UserId: this.commonService.getUserInfoFromLocalStorage("userId"),
      // MONTH_YEAR: this.commonService.getUserInfoFromLocalStorage("monthYear"),
      ActionBy: this.memorystore.getItem("userName"),
      UserId: this.memorystore.getItem("userId"),
      MONTH_YEAR: this.memorystore.getItem("monthYear"),
      CutoffDate: "",
      CutoffDateFrom: "",
      CutoffDateTo: "",
      ProcessBy: 0,
      TaskOwner: 0,
      MonthEndStatus: "", //item.monthEndStatus,
      CriticalActivity: -1,
      BUSINESSUNIT: "",
      PROCESS: "",
      PROCESS_ID: item.processID[0]["procesS_ID"],
      ActTypeID: 0,
      DAY: 0,
      // SUBGROUP_ID: this.commonService.getUserInfoFromLocalStorage("subgroupId"),
      SUBGROUP_ID: this.memorystore.getItem("subgroupId"),
      IsDependent: false,
      // ROL_ID: this.commonService.getUserInfoFromLocalStorage("roleId"),
      ROL_ID: this.memorystore.getItem("roleId"),
      URN: "",
      ActivityName: "",
      // SESSION_ID: this.commonService.getUserInfoFromLocalStorage("token"),
      // DOCUMENT_TYPE_ID: this.commonService.getUserInfoFromLocalStorage("documentTypeId"),
      SESSION_ID: this.memorystore.getItem("token"),
      DOCUMENT_TYPE_ID: this.memorystore.getItem("documentTypeId"),
      lstTable: item.dynamicFilter
    };
    await this.dataService.postDataPromise("ConfigureMonthEnd/MonthEndStatusRep", body).then(res => {
      if (res != undefined && res.data.table != undefined) {
        this.tableRows = res.data.table;
        this.gridBackup = this.tableRows;
      }
    });

    this.tableColumns = this.tableRows.length > 0 ? Object.keys(this.tableRows[0]) : [];
    let keysToRemove = ["urn", "process_id", "document_detail_Id", "documenT_TYPE_ID", "imgsrc", "activityRefID",
      "mappingRefId", "monthRefId", 'follow Up', 'remove from Calendar', 'escalate', 'schedule Status'];
    this.tableColumns = this.tableColumns.filter(el => !keysToRemove.includes(el));
    this.gridBackupColumns = [...this.tableColumns];
    this.gridBackupColumns.push("urn");
    this.tableTitle = item.name;
    this.isActivityStatusTableOpen = true;
  }

  closeWorkflowStatusTable() {
    this.isActivityStatusTableOpen = false;
    this.tableColumns = [];
    this.tableRows = [];
    this.tableTitle = "";
  }

  downloadExcel() {
    // this.commonService.exportAsExcelFile(
    //   this.commonService.remPropFrmArrOfObjs(this.gridBackup, [
    //     "process_id", "document_detail_Id", "documenT_TYPE_ID", 
    //     "imgsrc", "activityRefID", "mappingRefId", "monthRefId", 
    //     'follow Up', 'remove from Calendar', 'escalate'
    //   ]), 
    //   this.tableTitle+"_Activity_Details");
  }

  updateFilter(event: any) {
    //var val = event.target.value.toLowerCase();
    var val = event.toLowerCase();
    var temp = this.gridBackup.filter((d) => {
      let res = false;
      this.gridBackupColumns.forEach(x => {
        let v = (d[x] != null && d[x] != undefined) ? d[x] : -1;
        res = res || v.toString().toLowerCase().indexOf(val) !== -1;
      });
      return res || !val;
    });
    this.tableRows = temp;
  }

  getColumnParameters(col, parameter = "name") {
    if (parameter.toLowerCase() == "width") {
      let val = Math.ceil(col.length * 10);
      return val < 150 ? 150 : val;
    } else {
      if (col.toLowerCase() == "schedule name" || col.toLowerCase() == "schedule_name") {
        return "schedule";
      }
      col = col.replace('tcs ', 'TCS ').replace('fol ', 'FOL ').replace('tfh ', 'TFH ');
      return col;
    }
    return 150;
  }

  initActivityFields() {
    let formControls = {};
    this.frm = new FormGroup(formControls);
    this.frmInitialValues = this.frm.value;
  }
  populateFields(arr) {
    arr.forEach(x => {
      let optionsDict = {};
      let optionsDictById = {};
      let optionsArr = [];
      let optionObj = [];
      if (x.controL_TYPE == "DROPDOWN") {
        let names = x.fixeD_VALUE_LIST.split(',');
        let ids = x.fixeD_VALUE_ID_LIST.split(',');
        for (let i = 0; i < ids.length; i++) {
          let id = ids[i] === undefined ? ids[i] : ids[i].trim().replace('&amp;', "&");
          let name = names[i] === undefined ? names[i] : names[i].trim().replace('&amp;', "&");
          optionsDict[name] = id;
          optionsDictById[id] = name;
          optionsArr.push(name);
          optionObj.push({
            id: id,
            name: name
          });
        }
      }
      this.fields.push({
        controlType: x.controL_TYPE,
        dbColumnName: x.dB_COLUMN_NAME,
        dbColumnValue: x.dB_COLUMN_VALUE,
        isDependant: x.iS_DEPENDENT == 0 ? false : true,
        isReadOnly: x.iS_READONLY == 0 ? false : true,
        isReadOnlyForAdhoc: x.iS_READONLYForAdhoc == 1 ? true : false,
        mandatoryForQueue: x.mandatorY_FOR_QUEUE == "Y" ? true : false,
        validationType: x.validatioN_TYPE,
        maximumLength: x.maximuM_LENGTH,
        parentFieldConfigId: x.parenT_FIELD_CONFIG_ID,
        parentFieldConfigName: x.parenT_FIELD_CONFIG_NAME,
        setDefaultDate: x.seT_DEFAULT_DATE == 0 ? false : true,
        toolTip: x.toolTip,
        order: x.fielD_ORDER,
        controlDimension: x.controlDimension,
        options: optionObj,
        optionsArr: optionsArr,
        optionsDict: optionsDict,
        optionsDictById: optionsDictById
      });
      this.frm.addControl(x.dB_COLUMN_NAME, new FormControl({
        value: x.dB_COLUMN_VALUE == null ? x.controL_TYPE == 'DROPDOWN' ? 0 : '' : optionsDictById[x.dB_COLUMN_VALUE],
        disabled: x.iS_READONLY == 1
      }, []));
    });
  }

  getDocumentGraphs(event: any) {
    // this.commonService.hideCloseStatusTable(true);
    // this.commonService.setUserInfoToLocalStorage("documentTypeName", doc.documentTypeName.toString(), 'getDocumentGraphs()');
    // this.commonService.setUserInfoToLocalStorage("documentTypeModule", doc.documentTypeModule.toString(), 'getDocumentGraphs()');
    // this.commonService.setUserInfoToLocalStorage("documentTypeId", doc.documentTypeId.toString(), 'getDocumentGraphs()');
    // this.activeDocument = doc.documentTypeId;

    this.closeWorkflowStatusTable();
    //// this.commonService.hideCloseWorkflowStatusTable(true);

    this.getGraphData(event.value);

  }

  async getGraphData(documentTypeId: number = 0) {

    // this.commonService.showHideLoader(true);
    // if (this.commonService.getUserInfoFromLocalStorage("isAdmin") === 'true') {
    if (this.memorystore.getItem("isAdmin") === 'true') {
      this.Compliance_Title = 'Overall Compliance(MoM)';
    }
    else {
      this.Compliance_Title = 'My Compliance(MoM)';
    }

    let monthYear: string = null;// this.commonService.getUserInfoFromLocalStorage("monthYear");
    if (monthYear == null || monthYear == "null" || monthYear == undefined || monthYear == "undefined") {
      monthYear = "";
    }

    if (documentTypeId == 0) {
      // this.commonService.getUserInfoFromLocalStorage("documentTypeId");
      this.memorystore.getItem("documentTypeId");
    }


    let body = {
      // ActionBy: this.commonService.getUserInfoFromLocalStorage("userName"),
      MONTH_YEAR: monthYear,
      SUBGROUP_ID: Number(this.commonService.selectedSubgroup),
      ROLE_ID: Number(this.commonService.selectedRole),
      DOCUMENT_TYPE_ID: 0,//this.commonService.getUserInfoFromLocalStorage("documentTypeId"),
      // USER_ID: Number(this.commonService.getUserInfoFromLocalStorage("userId")),
      USER_ID: Number(this.memorystore.getItem("userId")),
      //lstTable: this.lstTable
    };
    await this.dataService.postDataPromise("unitdashboard", body).then((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        // this.commonService.showHideLoader(true);      
        if (res != null) {
          //this.totalCount = 0;
          this.totalCount = 0;
          this.totalCriticalCount = 0;

          // this.commonService.showHideLoader(true);
          if (res.data.Table14 != undefined && res.data.Table14.length > 0 && this.activeDocument == 0 && documentTypeId == res.data.Table14[0].DOCUMENT_TYPE_ID) {
            // this.commonService.setUserInfoToLocalStorage("documentTypeId", res.data.Table14[0].DOCUMENT_TYPE_ID);
            // this.commonService.setUserInfoToLocalStorage("documentTypeName", res.data.Table14[0].DOCTYPE_NAME);
            // this.commonService.setUserInfoToLocalStorage("documentTypeName", res.data.Table14[0].DOCTYPE_MODULE_NAME);
            this.memorystore.setItem("documentTypeId", res.data.Table14[0].DOCUMENT_TYPE_ID);
            this.memorystore.setItem("documentTypeName", res.data.Table14[0].DOCTYPE_NAME);
            this.memorystore.setItem("documentTypeName", res.data.Table14[0].DOCTYPE_MODULE_NAME);
          }

          if (res.data.Table3 != undefined && res.data.Table3.length > 0) {
            let mnthYear = res.data.Table14[0].DOCTYPE_NAME;
            // if (this.commonService.getUserInfoFromLocalStorage("periodConcept")==1) {
            //   if (mnthYear.length==6 || mnthYear.length==7)
            //     mnthYear = this.monthDefault;
            // }

            // this.commonService.setUserInfoToLocalStorage("monthYear", mnthYear);
            this.memorystore.setItem("monthYear", mnthYear);
            //this.totalCount = res.data.Table3[0].totaL_ACTIVITY;
            this.totalCount = res.data.Table3[0].TOTAL_ACTIVITY;
          }

          // this.selectedDisplay = this.commonService.getUserInfoFromLocalStorage("selectedDisplay");
          this.selectedDisplay = this.memorystore.getItem("selectedDisplay");
          this.missedGraphData = res.data.Table;
          this.graphData = res.data.Table1;
          this.calendarDaywiseData = res.data.Table2;
          this.statusCountdata = res.data.Table3;
          this.calendarHolidayMonthData = res.data.Table9;
          this.invoiceDueDatewise = res.data.Table10;
          this.slaGraphData = res.data.Table11;
          this.calendarPositionData = res.data.Table12;
          this.activityGrowthData = res.data.Table15;
          this.activityTypeData = res.data.Table16;
          //this.activityClosureData = res.data.Table17;
          this.activityPerformanceData = res.data.Table18;

          this.documentTabList = [];
          this.overallActivityList = [];
          this.overallActivityGraphList = [];
          this.criticalActivityList = [];
          this.actionTable = [];
          this.actionTableColumns = [];
          // this.commonService.showHideLoader(true);

          if (res.data.Table5 != undefined && res.data.Table5.length > 0) {

            this.actionText = res.data.Table5[0]['ActionName'];

          }

          // if (res.data.Table4 != undefined && res.data.Table4.length > 0) {

          //   this.isAction=true;
          //   this.actionTableMore = res.data.Table4.length>3?true:false;
          //   this.actionTable = res.data.Table4.length>3?res.data.Table4.slice(0, 3):res.data.Table4;
          //   this.actionTableColumns = this.actionTable.length > 0 ? Object.keys(this.actionTable[0]) : [];
          //   let keysToRemove = ["activityFullName", "circleImgsrc", "status"];
          //   this.actionTableColumns = this.actionTableColumns.filter(el => !keysToRemove.includes(el));

          // }

          if (res.data.Table13 != undefined && res.data.Table13.length > 0) {

            this.documentTabList = []
            res.data.Table13.forEach((item: { [x: string]: any; }) => {
              if (item.ISDEFAULT == 1 && this.activeDocument == 0) {
                this.activeDocument = item.DOCUMENT_TYPE_ID;
                // this.commonService.setUserInfoToLocalStorage("documentTypeName", item.DOCTYPE_NAME);
                // this.commonService.setUserInfoToLocalStorage("documentTypeId", item.DOCUMENT_TYPE_ID);
                // this.commonService.setUserInfoToLocalStorage("documentTypeModule", item.DOCTYPE_MODULE_NAME);
                this.memorystore.setItem("documentTypeName", item.DOCTYPE_NAME);
                this.memorystore.setItem("documentTypeId", item.DOCUMENT_TYPE_ID);
                this.memorystore.setItem("documentTypeModule", item.DOCTYPE_MODULE_NAME);
              }

              if (item.DOCTYPE_MODULE_NAME == "PI IDEAS") {

                this.documentTabList.push({
                  documentTypeId: item.DOCUMENT_TYPE_ID,
                  documentTypeName: item.DOCTYPE_NAME,
                  documentTypeModule: item.DOCTYPE_MODULE_NAME,
                  documentTypeImage: "../../assets/img/icons/calendar3-fill.png"
                });
              } else {

                this.documentTabList.push({
                  documentTypeId: item.DOCUMENT_TYPE_ID,
                  documentTypeName: item.DOCTYPE_NAME,
                  documentTypeModule: item.DOCTYPE_MODULE_NAME,
                  documentTypeImage: "../../assets/img/icons/calendar-minus-fill.png"
                });
              }
            });
          }



          // if (res.data.Table3 != undefined && res.data.Table3.length>0 && res.data.Table21 != undefined && res.data.Table21.length>0) {
          if (res.data.Table3 != undefined && res.data.Table3.length > 0) {

            this.overallActivityGraphList.push({
              name: "Draft Idea",
              monthEndStatus: "Draft Idea",
              value: res.data.Table3[0].DraftIdea_WORKFLOW,
              color: res.data.Table3[0].DraftIdeaColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].DraftIdea_WORKFLOW) / this.totalCount) * 100)
            });

            this.overallActivityGraphList.push({
              name: "TPM Approval",
              monthEndStatus: "TPM Approval",
              value: res.data.Table3[0].TPM_approval_WORKFLOW,
              color: res.data.Table3[0].TPM_approvalColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].TPM_approval_WORKFLOW) / this.totalCount) * 100)
            });
            this.overallActivityGraphList.push({
              name: "SME Query",
              monthEndStatus: "SME Query",
              value: res.data.Table3[0].SME_Query_WORKFLOW,
              color: res.data.Table3[0].SME_QueryColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].SME_Query_WORKFLOW) / this.totalCount) * 100)
            });

            this.overallActivityGraphList.push({
              name: "TPM Query",
              monthEndStatus: "TPM Query",
              value: res.data.Table3[0].TPM_Query_WORKFLOW,
              color: res.data.Table3[0].TPM_QueryColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].TPM_Query_WORKFLOW) / this.totalCount) * 100)

            });

            this.overallActivityGraphList.push({
              name: "Implemetation",
              monthEndStatus: "Implemetation",
              value: res.data.Table3[0].Implemetation_WORKFLOW,
              color: res.data.Table3[0].ImplemetationColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].Implemetation_WORKFLOW) / this.totalCount) * 100)
            });
            this.overallActivityGraphList.push({
              name: "Rejected",
              monthEndStatus: "Rejected",
              value: res.data.Table3[0].Rejected_WORKFLOW,
              color: res.data.Table3[0].RejectedColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].Rejected_WORKFLOW) / this.totalCount) * 100)
            });
            this.overallActivityGraphList.push({
              name: "Need Revalidation",
              monthEndStatus: "Need Revalidation",
              value: res.data.Table3[0].Trash_WORKFLOW,
              color: res.data.Table3[0].TrashColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].Trash_WORKFLOW) / this.totalCount) * 100)
            });

            this.overallActivityGraphList.push({
              name: "TPM Response",
              monthEndStatus: "TPM Response",
              value: res.data.Table3[0].TPM_Response_WORKFLOW,
              color: res.data.Table3[0].TPM_ResponseColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].TPM_Response_WORKFLOW) / this.totalCount) * 100)
            });

            this.overallActivityGraphList.push({
              name: "SME Review",
              monthEndStatus: "SME Review",
              value: res.data.Table3[0].SME_Review_WORKFLOW,
              color: res.data.Table3[0].SME_ReviewColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].SME_Review_WORKFLOW) / this.totalCount) * 100)
            });

            this.overallActivityGraphList.push({
              name: "Design",
              monthEndStatus: "Design",
              value: res.data.Table3[0].Design_WORKFLOW,
              color: res.data.Table3[0].DesignColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].Design_WORKFLOW) / this.totalCount) * 100)
            });


            this.overallActivityGraphList.push({
              name: "Testing",
              monthEndStatus: "Testing",
              value: res.data.Table3[0].Testing_WORKFLOW,
              color: res.data.Table3[0].TestingColor_code,
              percentage: Math.round((parseInt(res.data.Table3[0].Testing_WORKFLOW) / this.totalCount) * 100)
            });


            // this.overallActivityGraphList.push({
            //   name: "Query to TFH",
            //   monthEndStatus: "Query to TFH",
            //   value: res.data.Table3[0]["querY_TO_TFH_WORKFLOW"],
            //   color: res.data.Table3[0]["queryToTFHColor_code"],
            //   percentage: Math.round((parseInt(res.data.Table3[0]["querY_TO_TFH_WORKFLOW"])/this.totalCount)*100)
            // });

            // this.overallActivityGraphList.push({
            //   name: "Request for Info",
            //   monthEndStatus: "Request for Info",
            //   value: res.data.Table3[0]["requesT_FOR_INFO_WORKFLOW"],
            //   color: res.data.Table3[0]["requestForInfoColor_code"],
            //   percentage: Math.round((parseInt(res.data.Table3[0]["requesT_FOR_INFO_WORKFLOW"])/this.totalCount)*100)
            // });

            // this.overallActivityGraphList.push({
            //   name: "Completed",
            //   monthEndStatus: "Completed",
            //   value: res.data.Table3[0]["completeD_WORKFLOW"],
            //   color: res.data.Table3[0]["completedColor_code"],
            //   percentage: Math.round((parseInt(res.data.Table3[0]["completeD_WORKFLOW"])/this.totalCount)*100)
            // });

            this.overallActivityList.push({
              name: "Implemetation",
              monthEndStatus: "Implemetation",
              //processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'Implemetation')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'Implemetation')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'Implemetation')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].Implemetation_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].Implemetation_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "completed-flip-card"

            });

            this.overallActivityList.push({
              name: "TPM Approval",
              monthEndStatus: "TPM Approval",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'TPM Approval')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'TPM Approval')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'TPM Approval')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].TPM_approval_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].TPM_approval_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "initiated-flip-card"
            });

            this.overallActivityList.push({
              name: "TPM Query",
              monthEndStatus: "TPM Query",
              processID: res.data.Table3.filter(x => x.procesS_NAME === 'SME Query'),
              value: res.data.Table3[0].TPM_Query_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].TPM_Query_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "in-progress-flip-card"
            });

            this.overallActivityList.push({
              name: "SME Query",
              monthEndStatus: "SME Query",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'SME Query')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'SME Query')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'SME Query')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].SME_Query_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].SME_Query_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "preparer-rework-flip-card"
            });

            this.overallActivityList.push({
              name: "Draft Idea",
              monthEndStatus: "Draft Idea",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'Draft Idea')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'Draft Idea')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'Draft Idea')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].DraftIdea_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].DraftIdea_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "reviewer-flip-card"
            });

            this.overallActivityList.push({
              name: "SME Response",
              monthEndStatus: "SME Response",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'SME Response')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'SME Response')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'SME Response')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].SME_Response_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].SME_Response_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "reviewer-flip-card"
            });

            this.overallActivityList.push({
              name: "TPM Response",
              monthEndStatus: "TPM Response",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'TPM Response')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'TPM Response')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'TPM Response')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].TPM_Response_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].TPM_Response_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "request-for-info-flip-card"
            });


            this.overallActivityList.push({
              name: "SME Review",
              monthEndStatus: "SME Review",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'SME Review')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'SME Review')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'SME Review')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].SME_Review_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].SME_Review_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "reviewer-rework-flip-card"
            });
            // this.overallActivityList.push({
            //   name: "Rejected",
            //   monthEndStatus: "Rejected",
            //   processID: res.data.Table3.filter(x =>  x.procesS_NAME === 'Rejected'),
            //   value: res.data.Table3[0].Rejected_WORKFLOW,
            //   percentage: Math.round((parseInt(res.data.Table3[0].Rejected_WORKFLOW)/this.totalCount)*100),
            //   dynamicFilter: this.lstTable
            // });
            // this.overallActivityList.push({
            //   name: "Trash",
            //   monthEndStatus: "Trash",
            //   processID: res.data.Table3.filter(x =>  x.procesS_NAME === 'Trash'),
            //   value: res.data.Table3[0].Trash_WORKFLOW,
            //   percentage: Math.round((parseInt(res.data.Table3[0].Trash_WORKFLOW)/this.totalCount)*100),
            //   dynamicFilter: this.lstTable
            // }); 

            this.overallActivityList.push({
              name: "Design",
              monthEndStatus: "Design",
              // processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'Design')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'Design')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'Design')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].Design_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].Design_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "tfh-approver-flip-card"
            });

            this.overallActivityList.push({
              name: "Build",
              monthEndStatus: "Build",
              processID: res.data.Table3.filter(x => x.procesS_NAME === 'Build'),
              value: res.data.Table3[0].Build_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].Build_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "fol-approver-rework-flip-card"
            });

            this.overallActivityList.push({
              name: "Testing",
              monthEndStatus: "Testing",
              //processID: res.data.Table21.filter(x =>  x.PROCESS_NAME === 'Testing')[0].PROCESS_ID,
              processID: res.data.Table21.filter(x => x.PROCESS_NAME === 'Testing')['length'] > 0 ? res.data.Table21.filter(x => x.PROCESS_NAME === 'Testing')[0].PROCESS_ID : 0,
              value: res.data.Table3[0].Testing_WORKFLOW,
              percentage: Math.round((parseInt(res.data.Table3[0].Testing_WORKFLOW) / this.totalCount) * 100),
              dynamicFilter: this.lstTable,
              class: "tfh-approved-flip-card"
            });

            // this.overallActivityList.push({
            //   name: "Query to TFH",
            //   monthEndStatus: "Query to TFH",
            //   processID: res.data.Table3.filter(x =>  x.procesS_NAME === 'Query to TFH'),
            //   value: res.data.Table3[0]["querY_TO_TFH_WORKFLOW"],
            //   percentage: Math.round((parseInt(res.data.Table3[0]["querY_TO_TFH_WORKFLOW"])/this.totalCount)*100),
            //   dynamicFilter: this.lstTable,
            //   class: "query-to-TFH-flip-card"
            // });

          }
          //this.overallActivityList =this.overallActivityList.filter (x => x.value >0)
          if (res.data.Table1 != undefined && res.data.Table1.length > 0) {

            let tempInitiated: any = {};
            let tempCompleted: any = {};
            let tempInProgress: any = {};
            let tempPreparerRework: any = {};
            let tempSentforReviewer: any = {};
            let tempReviewerRework: any = {};
            let tempRejected: any = {};
            let tempTerminated: any = {};
            let tempSentforFOLApprover: any = {};
            let tempRequestforInfo: any = {};
            let tempSentforTFHApprover: any = {};
            let tempFOLApproverRework: any = {};
            let tempTFHApproved: any = {};
            let tempQuerytoTFH: any = {};

            res.data.Table1.forEach((item: { [x: string]: any; }) => {

              this.totalCriticalCount += item.TotCritical;

              if (item.Status == "DRAFT IDEA") {
                tempInitiated["name"] = "DRAFT IDEA";
                tempInitiated["value"] = item.TotCritical;
                tempInitiated["percentage"] = item.XPercentage;
                tempInitiated["color"] = "#02EDED";
                tempInitiated["class"] = "initiated-flip-card";
              } else if (item.Status == "SME Response") {
                tempInProgress["name"] = "SME Response";
                tempInProgress["value"] = item.TotCritical;
                tempInProgress["percentage"] = item.XPercentage;
                tempInProgress["color"] = "#669900";
                tempInProgress["class"] = "in-progress-flip-card";
              } else if (item.Status == "TPM approval") {
                tempPreparerRework["name"] = "TPM approval";
                tempPreparerRework["value"] = item.TotCritical;
                tempPreparerRework["percentage"] = item.XPercentage;
                tempPreparerRework["color"] = "#5fe072";
                tempPreparerRework["class"] = "preparer-rework-flip-card";
              } else if (item.Status == "Design") {
                tempSentforReviewer["name"] = "Design";
                tempSentforReviewer["value"] = item.TotCritical;
                tempSentforReviewer["percentage"] = item.XPercentage;
                tempSentforReviewer["color"] = "#8B0000";
                tempSentforReviewer["class"] = "reviewer-flip-card";
              } else if (item.Status == "Build") {
                tempReviewerRework["name"] = "Build";
                tempReviewerRework["value"] = item.TotCritical;
                tempReviewerRework["percentage"] = item.XPercentage;
                tempReviewerRework["color"] = "#B0D0E8";
                tempReviewerRework["class"] = "reviewer-rework-flip-card";
              }
              else if (item.Status == "Rejected") {
                tempRejected["name"] = "Rejected";
                tempRejected["value"] = item.TotCritical;
                tempRejected["percentage"] = item.XPercentage;
                tempRejected["color"] = "#11293B";
                tempRejected["class"] = "rejected-flip-card";
              }
              else if (item.Status == "Trash") {
                tempTerminated["name"] = "Trash";
                tempTerminated["value"] = item.TotCritical;
                tempTerminated["percentage"] = item.XPercentage;
                tempTerminated["color"] = "#669900";
                tempTerminated["class"] = "terminated-flip-card";
              }
              else if (item.Status == "Hold") {
                tempSentforFOLApprover["name"] = "Hold";
                tempSentforFOLApprover["value"] = item.TotCritical;
                tempSentforFOLApprover["percentage"] = item.XPercentage;
                tempSentforFOLApprover["color"] = "#00CED1";
                tempSentforFOLApprover["class"] = "fol-approver-flip-card";
              } else if (item.Status == "SME Query") {
                tempFOLApproverRework["name"] = "SME Query";
                tempFOLApproverRework["value"] = item.TotCritical;
                tempFOLApproverRework["percentage"] = item.XPercentage;
                tempFOLApproverRework["color"] = "#FFA07A";
                tempFOLApproverRework["class"] = "fol-approver-rework-flip-card";
              } else if (item.Status == "TPM approval") {
                tempSentforTFHApprover["name"] = "TPM approval";
                tempSentforTFHApprover["value"] = item.TotCritical;
                tempSentforTFHApprover["percentage"] = item.XPercentage;
                tempSentforTFHApprover["color"] = "#7B68EE";
                tempSentforTFHApprover["class"] = "tfh-approver-flip-card";
              } else if (item.Status == "Implemetation") {
                tempTFHApproved["name"] = "Implemetation";
                tempTFHApproved["value"] = item.TotCritical;
                tempTFHApproved["percentage"] = item.XPercentage;
                tempTFHApproved["color"] = "#FFA07A";
                tempTFHApproved["class"] = "tfh-approved-flip-card";
              } else if (item.Status == "TPM Response") {
                tempQuerytoTFH["name"] = "TPM Response";
                tempInitiated["value"] = item.TotCritical;
                tempQuerytoTFH["percentage"] = item.XPercentage;
                tempQuerytoTFH["color"] = "#DC143C";
                tempQuerytoTFH["class"] = "query-to-TFH-flip-card"
              } else if (item.Status == "SME Review") {
                tempRequestforInfo["name"] = "SME Review";
                tempRequestforInfo["value"] = item.TotCritical;
                tempRequestforInfo["percentage"] = item.XPercentage;
                tempRequestforInfo["color"] = "#ff8f3d";
                tempRequestforInfo["class"] = "request-for-info-flip-card";
              } else if (item.Status == "Implemetation") {
                tempCompleted["name"] = "Implemetation";
                tempCompleted["value"] = item.TotCritical;
                tempCompleted["percentage"] = item.XPercentage;
                //tempCompleted["color"] = "#235175";
                tempCompleted["color"] = "#B365E7";
                tempCompleted["class"] = "completed-flip-card";

              }
            });

            if (!tempCompleted.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "Implemetation",
                value: 0,
                percentage: 0,
                color: "#FB4185",
                class: "completed-flip-card"
              });
            } else {
              tempCompleted["percentage"] = Math.round((tempCompleted["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempCompleted);
            }

            if (!tempInitiated.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "DRAFT IDEA",
                value: 0,
                percentage: 0,
                color: "#02EDED",
                class: "initiated-flip-card"
              });
            } else {
              tempInitiated["percentage"] = Math.round((tempInitiated["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempInitiated);
            }
            if (!tempInProgress.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "SME Response",
                value: 0,
                percentage: 0,
                color: "#41B7FB",
                class: "in-progress-flip-card"
              });
            } else {
              tempInProgress["percentage"] = Math.round((tempInProgress["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempInProgress);
            }
            if (!tempPreparerRework.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "TPM approval",
                value: 0,
                percentage: 0,
                color: "#02EDED",
                class: "preparer-rework-flip-card"
              });
            } else {
              tempPreparerRework["percentage"] = Math.round((tempPreparerRework["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempPreparerRework);
            }

            if (!tempSentforReviewer.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "Design",
                value: 0,
                percentage: 0,
                color: "#0C5E8D",
                class: "reviewer-flip-card"

              });
            } else {
              tempSentforReviewer["percentage"] = Math.round((tempSentforReviewer["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempSentforReviewer);
            }

            if (!tempSentforFOLApprover.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "Hold",
                value: 0,
                percentage: 0,
                color: "#A4E91C",
                class: "fol-approver-flip-card"
              });
            } else {
              tempSentforFOLApprover["percentage"] = Math.round((tempSentforFOLApprover["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempSentforFOLApprover);
            }

            if (!tempRequestforInfo.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "SME Review",
                value: 0,
                percentage: 0,
                color: "#B365E7",
                class: "request-for-info-flip-card"

              });
            } else {
              tempRequestforInfo["percentage"] = Math.round((tempRequestforInfo["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempRequestforInfo);
            }

            if (!tempReviewerRework.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "TCS Reviewer Rework",
                value: 0,
                percentage: 0,
                color: "#edae42",
                class: "reviewer-rework-flip-card"

              });
            } else {
              tempReviewerRework["percentage"] = Math.round((tempReviewerRework["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempReviewerRework);
            }

            if (!tempRejected.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "Rejected",
                value: 0,
                percentage: 0,
                color: "#0081CC",
                class: "rejected-flip-card"

              });
            } else {
              tempRejected["percentage"] = Math.round((tempRejected["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempRejected);
            }

            if (!tempTerminated.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "Trash",
                value: 0,
                percentage: 0,
                color: "#CC004B",
                class: "terminated-flip-card"

              });
            } else {
              tempTerminated["percentage"] = Math.round((tempTerminated["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempTerminated);
            }




            if (!tempSentforTFHApprover.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "TPM approval",
                value: 0,
                percentage: 0,
                color: "#02EDED",
                class: "tfh-approver-flip-card"
              });
            } else {
              tempSentforTFHApprover["percentage"] = Math.round((tempSentforTFHApprover["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempSentforTFHApprover);
            }


            if (!tempFOLApproverRework.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "SME Query",
                value: 0,
                percentage: 0,
                color: "#651F93",
                class: "fol-approver-rework-flip-card"

              });
            } else {
              tempFOLApproverRework["percentage"] = Math.round((tempFOLApproverRework["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempFOLApproverRework);
            }

            if (!tempTFHApproved.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "Implemetation",
                value: 0,
                percentage: 0,
                color: "#EEB817",
                class: "tfh-approved-flip-card"

              });
            } else {
              tempTFHApproved["percentage"] = Math.round((tempTFHApproved["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempTFHApproved);
            }

            if (!tempQuerytoTFH.hasOwnProperty("name")) {
              this.criticalActivityList.push({
                name: "TPM Response",
                value: 0,
                percentage: 0,
                color: "#DC143C",
                class: "query-to-TFH-flip-card"

              });
            } else {
              tempQuerytoTFH["percentage"] = Math.round((tempQuerytoTFH["value"] / this.totalCriticalCount) * 100);
              this.criticalActivityList.push(tempQuerytoTFH);
            }

          } else {

            this.criticalActivityList.push({
              name: "Implemetation",
              value: 0,
              percentage: 0,
              color: "#EEB817",
              class: "completed-flip-card"

            });

            this.criticalActivityList.push({
              name: "DRAFT IDEA",
              value: 0,
              percentage: 0,
              color: "#edae42",
              class: "initiated-flip-card"
            });
            this.criticalActivityList.push({
              name: "TPM approval",
              value: 0,
              percentage: 0,
              color: "#edae42",
              class: "in-progress-flip-card"
            });
            this.criticalActivityList.push({
              name: "SME Query",
              value: 0,
              percentage: 0,
              color: "#edae42",
              class: "preparer-rework-flip-card"
            });
            this.criticalActivityList.push({
              name: "TPM Query",
              value: 0,
              percentage: 0,
              color: "#edae42",
              class: "reviewer-flip-card"
            });

            this.criticalActivityList.push({
              name: "TPM approval",
              value: 0,
              percentage: 0,
              color: "#00CED1",
              class: "fol-approver-flip-card"
            });

            this.criticalActivityList.push({
              name: "SME Response",
              value: 0,
              percentage: 0,
              color: "#ff8f3d",
              class: "request-for-info-flip-card"
            });


            this.criticalActivityList.push({
              name: "TPM Response",
              value: 0,
              percentage: 0,
              color: "#B0D0E8",
              class: "reviewer-rework-flip-card"
            });
            // this.criticalActivityList.push({
            //   name: "Rejected",
            //   value: 0,
            //   percentage: 0,
            //   color: "#11293B",
            //   class: "rejected-flip-card"
            // });
            // this.criticalActivityList.push({
            //   name: "Trash",
            //   value: 0,
            //   percentage: 0,
            //   color: "#669900",
            //   class: "terminated-flip-card"
            // }); 

            this.criticalActivityList.push({
              name: "Hold",
              value: 0,
              percentage: 0,
              color: "#7B68EE",
              class: "tfh-approver-flip-card"
            });


            this.criticalActivityList.push({
              name: "SME Query",
              value: 0,
              percentage: 0,
              color: "#FFA07A",
              class: "fol-approver-rework-flip-card"
            });

            this.criticalActivityList.push({
              name: "TPM Query",
              value: 0,
              percentage: 0,
              color: "#FFA07A",
              class: "tfh-approved-flip-card"
            });

            this.criticalActivityList.push({
              name: "Design",
              value: 0,
              percentage: 0,
              color: "#DC143C",
              class: "query-to-TFH-flip-card"
            });

          }
          ////this.criticalActivityList =this.criticalActivityList.filter (x => x.value >0)


          // if (res.data.table6!=undefined && res.data.table6.length>0) {
          //   let elem = document.getElementById('disable-proxy');

          // }

          if (res.data.Table19 != undefined && res.data.Table19.length > 0) {
            this.monthDropdown = res.data.Table19;

            this.monthDefault = res.data.Table19[0].currentMonth;
            // this.commonService.setUserInfoToLocalStorage("monthYear", this.monthDefault);
            this.memorystore.setItem("monthYear", this.monthDefault);
          }

          if (res.data.table20 != undefined && res.data.table20.length > 0 && !this.showSearchBy) {
            this.showSearchBy = true;
            this.populateFields(res.data.table20);
          }

          this.loadGraphs();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  loadGraphs() {
    //this.commonService.showHideLoader(true);
    this.overallCompleted();
    //this.slaActivity();    
    this.criticalActivity();
    //this.activityGrowth();
    this.activityClosure();
    //this.overallPerformance();
    this.completedActivity();
    this.summaryChart();
    this.slaActivity();
    setInterval(() => {
      //  this.commonService.showHideLoader(false);
    }, 2000)
  }


  exportChart(chartId) {
    var svg: any = document.getElementById(chartId).querySelector("svg");
    // let chartName = chartId + '_' + this.commonService.getUserInfoFromLocalStorage('selectedDisplay') + '.png';
    let chartName = chartId + '_' + this.memorystore.getItem('selectedDisplay') + '.png';
    // downloadAsPng.saveSvgAsPng(svg, chartName);
  }

  overallCompleted() {
    let temp = [];
    let graphData = [];
    let graphColors = {};
    this.overallActivityGraphList = this.overallActivityGraphList.filter(x => x.value > 0)
    this.overallActivityGraphList.forEach((item: { value: any; name: any; percentage: any; color: any; }) => {
      temp = [];

      graphColors[item.name] = item.color;
      temp.push(item.name);
      temp.push(item.value);
      graphData.push(temp);

    });

    var donatChart = c3.generate({

      bindto: '#overallCompletedChart',
      data: {
        columns: graphData,
        type: 'donut',
        colors: graphColors,
        onclick: function (d, i) { },
        onmouseover: function (d, i) { },
        onmouseout: function (d, i) { }
      },
      donut: {
        title: ""
      }
    });
    // let chart = c3.generate({
    //   bindto: '#overallCompletedChart',
    //       data: {
    //           columns: [
    //               ['data1', 30, 200, 100, 400, 150, 250],
    //               ['data2', 50, 20, 10, 40, 15, 25]
    //           ]
    //       }
    //   });
  }

  slaActivity() {
    let temp = [];
    let graphData = [];
    let graphColors = {};

    this.slaGraphData.forEach((item: { name: any; totCount: any; coloR_CODE: any; }) => {
      temp = [];
      temp.push(item.name);
      temp.push(item.totCount);
      graphColors[item.name] = item.coloR_CODE;
      graphData.push(temp);
    });
    let piechart = c3.generate({
      bindto: '#sla-pie-chart',
      data: {
        columns: graphData,
        type: 'pie',
        colors: graphColors,
        onclick: (d, e) => {
          this.getSlaActivityTableData(d);
        }
      }
    });
  }

  criticalActivity() {
    let temp = [];
    let graphData = [];
    let graphColors = {};
    var cloneArray = JSON.parse(JSON.stringify(this.criticalActivityList));
    cloneArray = cloneArray.filter(x => x.value > 0)
    cloneArray.forEach((item: { value: any, name: any; percentage: any; color: any; }) => {
      temp = [];
      temp.push(item.name);
      temp.push(item.value);
      graphColors[item.name] = item.color;
      graphData.push(temp);
    });
    let criticalpiechart = c3.generate({
      bindto: '#critical-pie-chart',
      data: {
        columns: graphData,
        type: 'bar',
        colors: graphColors,
        onclick: (d, e) => {
          this.getCriticalTableData(d);
        },
        labels: true
      }
    });
  }

  activityGrowth() {
    let temp = [];
    let xAxisData = [];

    let balanceTB = ["Balance as Per TB"];
    let balanceSchedule = ["Balance as Per Schedule"];
    let valueAtRisk = ["Value need Focus"];

    let graphData = [];
    this.activityGrowthData.forEach((item) => {
      temp = [];
      xAxisData.push(item.monthName);
      balanceTB.push((Math.round(parseInt(item['balancePerTB']) / 1000)).toString());
      balanceSchedule.push((Math.round(parseInt(item['balancePerSchedule']) / 1000)).toString());
      valueAtRisk.push((Math.round(parseInt(item['valueAtRisk']) / 1000)).toString());

    });
    graphData.push(balanceTB);
    graphData.push(balanceSchedule);
    graphData.push(valueAtRisk);

    let activitygrowthchart = c3.generate({
      bindto: '#activity-growth-line-chart',
      data: {
        columns: graphData,
        type: 'bar',
        // onclick: function (d, element) {

        // },
        //  labels: true
        labels: {
          format: {

            "Balance as Per TB": function (d) {
              var parts = d.toString().split(".");
              parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              return parts.join(".");
            },
            "Balance as Per Schedule": function (d) {
              var parts = d.toString().split(".");
              parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              return parts.join(".");
            },
            "Value need Focus": function (d) {
              var parts = d.toString().split(".");
              parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              return parts.join(".");
            },

          }

        }
      },
      axis: {
        x: {
          type: 'category',
          categories: xAxisData,
        },
      },
      tooltip: {
        format: {

          value: function (value, ratio, id) {

            var parts = value.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
          }
        }
      },
    });
  }

  activityClosure() {
    let xAxisData = [];
    let graphData = [];

    let onTimeClosure = ["Implementation"];
    let terminatedClosure = ["Trash"];
    let rejectedClosure = ["Rejected"];
    let scheduleCount = ["Total Idea"];


    this.activityClosureData.forEach(item => {
      xAxisData.push(item["monthName"]);

      onTimeClosure.push(item["Implementation"]);
      terminatedClosure.push(item["Trash"]);
      rejectedClosure.push(item["Rejected"]);
      scheduleCount.push(item["overall Idea Count"]);
    });

    graphData.push(onTimeClosure);
    // graphData.push(terminatedClosure);
    // graphData.push(rejectedClosure);
    graphData.push(scheduleCount);

    let activityclosurechart = c3.generate({
      bindto: '#activity-closure-line-chart',
      data: {
        columns: graphData,
        // columns: [['Completed', 7, 1, 5]],
        // onclick: function (d, element) {
        // },
        type: 'bar',
        labels: true,
      },

      axis: {
        x: {
          type: 'category',
          categories: xAxisData,
        }
      },
    });
  }

  overallPerformance() {
    let xAxisData = [];
    let graphData = [];

    let compliance = ["Compliance"];
    let TotalSchedules = ["Total Schedules"];

    this.activityPerformanceData.forEach(item => {
      xAxisData.push(item["monthName"]);

      compliance.push(item["compliance"]);
      TotalSchedules.push(item["total Schedule"]);

    });

    graphData.push(compliance);
    graphData.push(TotalSchedules);

    var overallperformancechart = c3.generate({
      bindto: '#overall-performance-line-chart',
      data: {
        columns: graphData,

        axes: {
          "Total Schedules": 'y2'
        },
        types: {
          "Total Schedules": 'bar'
        },
        labels: {
          format: {
            Compliance: function (d) { return d + "%"; },
            "Total Schedules": function (d) { return d + ""; }
          }
        }
      },
      axis: {
        x: {
          type: 'category',
          categories: xAxisData,
        },
        y: {
          label: {
            text: 'Compliance%',
            position: 'outer-middle'
          },
          tick: {
            format: function (d) { return d + "%"; }
          }
        },
      }
    });
  }

  completedActivity() {
    let temp = [];
    let graphData = [];
    let graphColors = {};

    this.missedGraphData.forEach((item: { process_Name: any; totCompleted: any; coloR_CODE: any; }) => {
      temp = [];

      temp.push(item['Process_Name']);
      temp.push(item['TotCompleted']);
      graphData.push(temp);
      graphColors[item['Process_Name']] = item['COLOR_CODE'];
    });

    var delayedpiechart = c3.generate({
      bindto: '#completed-pie-chart',
      data: {
        columns: graphData,
        type: 'pie',
        colors: graphColors,
        onclick: (d, e) => {
          this.getCompletedTableData(d);
        }
      },
    });
  }

  summaryChart() {
    let xAxisData = [];

    let initiatedData = ["Draft Idea"];
    let inProgressData = ["TPM Approval"];
    let preparerReworkData = ["SME Query"];
    let sentReviewerData = ["TPM Query"];
    let completedData = ["Implemetation"];
    let reviewerReworkData = ["SME Response"];
    let sentFOLApproverData = ["TPM Response"];
    let requestForInfoData = ["SME Review"];
    let senttoTFHApproverData = ["Design"];
    let folApproverReworkData = ["Build"];
    let tfhApprovedData = ["Testing"];
    //let queryToTFHData = ["Query to TFH"]; 

    let rejectedData = ["Rejected"];
    let terminatedData = ["Trash"];

    /*  let initiatedData = [];
      let inProgressData = [];
      let preparerReworkData = [];
      let sentReviewerData = [];
      let completedData = [];
      let reviewerReworkData =  [];
      let sentFOLApproverData = [];
      let requestForInfoData = [];
      let senttoTFHApproverData = [];
      let folApproverReworkData = [];
      let tfhApprovedData = [];
      let queryToTFHData = [];
  */

    let graphData = [];
    let graphColors = {};

    this.invoiceDueDatewise.forEach((item) => {
      xAxisData.push(item['DueDate']);

      initiatedData.push(item['DRAFT IDEA']);
      inProgressData.push(item['TPM approval']);
      preparerReworkData.push(item['SME Response']);
      sentReviewerData.push(item['Hold']);
      reviewerReworkData.push(item['SME Query']);
      /*rejectedData.push(item.rejected);
      terminatedData.push(item.terminated); */
      sentFOLApproverData.push(item['TPM Query']);
      folApproverReworkData.push(item['TPM Response']);
      senttoTFHApproverData.push(item['SME Review']);
      tfhApprovedData.push(item['Design']);
      // queryToTFHData.push(item.query_to_TFH);
      requestForInfoData.push(item['Build']);
      completedData.push(item['Implemetation']);
    });

    /*
     if(checkarrayData(initiatedData)==false)
     {
      initiatedData.splice(0, 0, "Initiated")
      graphData.push(initiatedData);
     }
       
     if(checkarrayData(inProgressData)==false)
     {
      inProgressData.splice(0, 0, "In Progress")
      graphData.push(inProgressData);
     }
    
     if(checkarrayData(preparerReworkData)==false)
     {
      preparerReworkData.splice(0, 0, "TCS Preparer Rework")
      graphData.push(preparerReworkData);
     }
    
     if(checkarrayData(sentReviewerData)==false)
     {
      sentReviewerData.splice(0, 0, "Sent for TCS Reviewer")
      graphData.push(sentReviewerData);
     }
    
     if(checkarrayData(completedData)==false)
     {
      completedData.splice(0, 0, "Completed")
      graphData.push(completedData);
     }
    
     if(checkarrayData(reviewerReworkData)==false)
     {
      reviewerReworkData.splice(0, 0, "TCS Reviewer Rework")
      graphData.push(reviewerReworkData);
     }
    
     if(checkarrayData(sentFOLApproverData)==false)
     {
      sentFOLApproverData.splice(0, 0, "Sent for FOL Approver")
      graphData.push(sentFOLApproverData);
     }
    
     if(checkarrayData(requestForInfoData)==false)
     {
      requestForInfoData.splice(0, 0, "Request for Info")
      graphData.push(requestForInfoData);
     }
    
     if(checkarrayData(senttoTFHApproverData)==false)
     {
      senttoTFHApproverData.splice(0, 0, "Sent for TFH Approver")
      graphData.push(senttoTFHApproverData);
     }
    
     if(checkarrayData(folApproverReworkData)==false)
     {
      folApproverReworkData.splice(0, 0, "FOL Approver Rework")
      graphData.push(folApproverReworkData);
     }
    
     if(checkarrayData(tfhApprovedData)==false)
     {
      tfhApprovedData.splice(0, 0, "TFH Approved")
      graphData.push(tfhApprovedData);
     }
    
     if(checkarrayData(queryToTFHData)==false)
     {
      queryToTFHData.splice(0, 0, "Query to TFH")
      graphData.push(queryToTFHData);
     }
     */

    graphData.push(completedData);
    graphData.push(initiatedData);
    graphData.push(inProgressData);
    graphData.push(preparerReworkData);
    graphData.push(sentReviewerData);
    graphData.push(sentFOLApproverData);
    graphData.push(requestForInfoData);
    graphData.push(reviewerReworkData);
    graphData.push(senttoTFHApproverData);
    graphData.push(folApproverReworkData);
    graphData.push(tfhApprovedData);
    //graphData.push(queryToTFHData);


    /*graphData.push(rejectedData);
      graphData.push(terminatedData);*/

    let daysummarychart = c3.generate({
      bindto: '#day-summary-chart',

      data: {
        columns: graphData,
        type: 'bar',
        colors: graphColors,
        onclick: function (d, element) {

        },
        labels: true
      },
      grid: {
        x: {
          show: true
        },
        y: {
          show: true
        }
      },

      axis: {
        x: {
          type: 'category',
          categories: xAxisData,
        }
      },
      bar: {
        width: {
          ratio: 0.5
        }
      }
    });
  }

  async getSlaActivityTableData(d) {
    let body = {
      // MONTH_YEAR: this.commonService.getUserInfoFromLocalStorage("monthYear"),
      MONTH_YEAR: this.memorystore.getItem("monthYear"),
      SUBGROUP_ID: this.commonService.selectedSubgroup,
      CutoffDate: null,
      // USER_ID: this.commonService.getUserInfoFromLocalStorage("userId"),
      USER_ID: this.memorystore.getItem("userId"),
      ROL_ID: this.commonService.selectedRole,
      SLA: d.id,
      CriticalStatus: null,
      ActivityType: null,
      // DOCUMENT_TYPE_ID: this.commonService.getUserInfoFromLocalStorage("documentTypeId"),
      DOCUMENT_TYPE_ID: this.memorystore.getItem("documentTypeId"),
      lstTable: this.lstTable
    };

    await this.dataService.postDataPromise('UnitDashboardModel/GetUnitDashboardActivity', body).then((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.slaTableData = res.data.Table1;
        if (this.slaTableData.length > 0) {
          this.slaTableColumns = Object.keys(this.slaTableData[0]);
          let keysToRemove = ["schedule Status"];
          this.slaTableColumns = this.slaTableColumns.filter(el => !keysToRemove.includes(el));
        }
        this.isSlaChartTableOpen = true;
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }).catch((err: any) => {

      });
  }




  async getCriticalTableData(d) {
    let status = d.id;

    let body = {
      // MONTH_YEAR: this.commonService.getUserInfoFromLocalStorage("monthYear"),
      MONTH_YEAR: this.memorystore.getItem("monthYear"),
      SUBGROUP_ID: this.commonService.selectedSubgroup,
      CutoffDate: null,
      // USER_ID: this.commonService.getUserInfoFromLocalStorage("userId"),
      USER_ID: this.memorystore.getItem("userId"),
      ROL_ID: this.commonService.selectedRole,
      SLA: null,
      CriticalStatus: status,
      ActivityType: null,
      // DOCUMENT_TYPE_ID: this.commonService.getUserInfoFromLocalStorage("documentTypeId"),
      DOCUMENT_TYPE_ID: this.memorystore.getItem("documentTypeId"),
      lstTable: this.lstTable
    };

    await this.dataService.postDataPromise('UnitDashboardModel/UnitDashboardFullCalendarActivity', body).then((res) => {
      this.criticalTableData = res.data.table2;

      // this.criticalTableColumns = this.criticalTableData.length > 0 ? Object.keys(this.criticalTableData[0]) : [];
      if (this.criticalTableData.length > 0) {
        this.criticalTableColumns = Object.keys(this.criticalTableData[0]);
        let keysToRemove = ["schedule Status"];
        this.criticalTableColumns = this.criticalTableColumns.filter(el => !keysToRemove.includes(el));
      }
      else {
        this.criticalTableColumns = [];
      }
      this.isCriticalTableOpen = true;
    });
  }

  async getCompletedTableData(d) {

    let body = {
      // MONTH_YEAR: this.commonService.getUserInfoFromLocalStorage("monthYear"),
      MONTH_YEAR: this.memorystore.getItem("monthYear"),
      SUBGROUP_ID: this.commonService.selectedSubgroup,
      CutoffDate: null,
      // USER_ID: this.commonService.getUserInfoFromLocalStorage("userId"),
      USER_ID: this.memorystore.getItem("userId"),
      ROL_ID: this.commonService.selectedRole,
      SLA: null,
      CriticalStatus: null,
      ActivityType: d.id,
      // DOCUMENT_TYPE_ID: this.commonService.getUserInfoFromLocalStorage("documentTypeId"),
      DOCUMENT_TYPE_ID: this.memorystore.getItem("documentTypeId"),
      lstTable: this.lstTable
    };
    await this.dataService.postDataPromise('UnitDashboardModel/UnitDashboardFullCalendarActivity', body).then((res) => {
      this.completedTableData = res.data.Table3;

      if (this.completedTableData.length > 0) {
        this.completedTableColumns = Object.keys(this.completedTableData[0]);
        let keysToRemove = ["schedule Status"];
        this.completedTableColumns = this.completedTableColumns.filter(el => !keysToRemove.includes(el));
      }
      else {
        this.completedTableColumns = [];
      }
      this.isCompletedTableOpen = true;
    }).catch((err: any) => {
      //this.commonService.log("Response: ", err);
    });
  }

  onActionRowClick(event) {
    if (event.type == 'click') {
      this.router.navigate(['/monthend-list']);
    }
  }

  closeSlaChartTable() {
    this.isSlaChartTableOpen = false;
  }

  closeCriticalTable() {
    this.isCriticalTableOpen = false;
  }

  closeCompletedTable() {
    this.isCompletedTableOpen = false;
  }

  getSearchFieldValue() {
    this.lstTable = [];

    this.fields.forEach(x => {
      if (this.frm.value[x.dbColumnName] != undefined && this.frm.value[x.dbColumnName] != '' && this.frm.value[x.dbColumnName] != null && this.frm.value[x.dbColumnName] != '0') {
        this.lstTable.push({
          "ColumnName": x.dbColumnName,
          "ColumnValue1": this.frm.value[x.dbColumnName] != undefined ? this.frm.value[x.dbColumnName] : "",
          "ColumnValue2": ""
        });
      }
    });
  }

  nextPrevMonth(where: string) {
    // let monthYear: string = this.commonService.getUserInfoFromLocalStorage("monthYear").split('-');
    let monthYear: string = this.memorystore.getItem("monthYear").split('-');
    let newMonthYear: string = "";
    if (where == "next") {
      if (parseInt(monthYear[0]) == 12) {
        newMonthYear = "01" + "-" + (parseInt(monthYear[1]) + 1).toString();
      } else {
        newMonthYear = (parseInt(monthYear[0]) + 1).toString() + "-" + monthYear[1];
      }
    } else {
      if (parseInt(monthYear[0]) == 1) {
        newMonthYear = "12" + "-" + (parseInt(monthYear[1]) - 1).toString();
      } else {
        newMonthYear = (parseInt(monthYear[0]) - 1).toString() + "-" + monthYear[1];
      }
    }

    // this.commonService.setUserInfoToLocalStorage("monthYear", newMonthYear);
    this.memorystore.setItem("monthYear", newMonthYear);
    this.getGraphData();
  }

  changeDashboardData(event: any) {
    this.closeWorkflowStatusTable();
    // this.commonService.hideCloseWorkflowStatusTable(true);
    // this.commonService.setUserInfoToLocalStorage("monthYear", event.value);
    this.memorystore.setItem("monthYear", event.value);
    this.getSearchFieldValue();
    this.getGraphData();
  }

  changeFilterData(event: any) {
    this.closeWorkflowStatusTable();
    // this.commonService.hideCloseWorkflowStatusTable(true); 
    this.getSearchFieldValue();
    this.getGraphData();
  }
}

function checkarrayData(arrObj): boolean {
  let result = arrObj.every(function (e) {
    return e == 0;
  });
  return result;
}

